<template>
  <div class="user-center-wrapper" :class="type">
    <div class="user-info-con">
      <div class="user-info-item">
        <img class="user-thumb" :src="userThumb || 'https://f.msup.com.cn/center-default-user.png'"/>
        <div class="user-name">
          <p>{{ userName }}</p>
        </div>
      </div>
      <div class="img mob"></div>
    </div>
    <div class="user-center" v-if="!applySuccess">
      <div class="sider" :style="`--tabs-count:${tabsList.length};`">
        <div class="tabs-wrapper">
          <div class="tabs" :class="'selected' + selectedTab + ' tab-count-' + tabsList.length">
            <slot v-for="(item, index) in tabsList">
              <div
                v-if="item && item.text"
                :class="['tabs-pane', selectedTab === (item.key || index) ? 'selected' : '']"
                :key="'selectedTab'+index"
                @click="triggerTabs(item.key || index)"
              >
                <div>
                  <svg class="icon icon-left" aria-hidden="true" v-if="item.iconName">
                    <use :xlink:href="'#icon-' + item.iconName"></use>
                  </svg>
                  <i :class="`icon icon-left el-icon-${item.iconType}`" v-else-if="item.iconType"></i>
                  <p>{{ item.text }}</p>
                  <svg class="icon icon-right" aria-hidden="true">
                    <use xlink:href="#icon-right"></use>
                  </svg>
                </div>
              </div>
            </slot>
          </div>
        </div>
      </div>
      <div class="user-content">
        <MyTicket
          v-if="selectedTab === 0"
          :token="token"
          :sid="sid"
          :type="type"
          :key="timeStamp"
        ></MyTicket>
        <MyOrder
          v-else-if="selectedTab === 1 && !showInvoice"
          :token="token"
          :sid="sid"
          :type="type"
          @openInvoice="openInvoice"
          :key="timeStamp"
        ></MyOrder>
        <OpenInvoice
          v-else-if="selectedTab === 1 && showInvoice"
          :token="token"
          :sid="sid"
          :type="type"
          :userName="userName"
          :userPhone="userPhone"
          @applyInvoiceSuccess="applyInvoiceSuccess"
          :key="timeStamp"
        ></OpenInvoice>
        <MyCollect
          v-else-if="selectedTab === 4"
          :token="token"
          :sid="sid"
          :screenw="screenWidth"
          :key="timeStamp"
        ></MyCollect>
        <Settings
          v-else-if="selectedTab === 2"
          :token="token"
          :sid="sid"
          @modify="regetUserInfo"
          :key="timeStamp"
        ></Settings>
      </div>
    </div>
    <!-- 发票提交成功 -->
    <div v-else class="invoice-success">
      <div>
        <img src="https://f.msup.com.cn/common_apply_success.png" />
        <h4>提交成功!</h4>
      </div>
      <div class="invoice-success-con">
        <p><span>账户名称：</span>麦思博(北京)软件技术有限公司</p>
        <p><span>帐号：</span>912401 54800002818</p>
        <p><span>您还可以：</span><a @click.prevent="toHome()">返回首页</a></p>
      </div>
    </div>
    <div class="user-center-mob">
      <div class="my-ticket">
        <!-- <h2>我的门票信息</h2> -->
      </div>
      <div class="active-ticket"></div>
    </div>
  </div>
</template>

<script>
import { mixinSession } from '../mixin'
import MyTicket from '@/componentsNew/center/MyTicket.vue'
import MyOrder from '@/componentsNew/center/MyOrder.vue'
import OpenInvoice from '@/componentsNew/center/OpenInvoice.vue'
import Settings from '@/componentsNew/center/Settings.vue'
import MyCollect from '@/componentsNew/center/MyCollect.vue'

export default {
  name: 'UserCenter',
  mixins: [mixinSession],
  components: {
    MyTicket,
    MyOrder,
    OpenInvoice,
    Settings,
    MyCollect
  },
  data () {
    return {
      sid: '',
      type: 'mpd', // 会议类型
      homeUrl: '', // 网站首页
      // selectedTab: 0, // 0 我的门票、1我的订单、2我的收藏、3开具发票、4个人设置
      selectedTab: 0, // 0 我的门票、1我的订单/开具发票、4我的收藏、2个人设置
      tabsList: [
        { text: '我的门票', iconName: 'ticket', key: 0 },
        { text: '我的订单', iconName: 'record', key: 1 },
        { text: '我的收藏', iconName: '', iconType: 'star-on', key: 4 },
        { text: '个人设置', iconName: 'settings', key: 2 }
      ],
      userName: '',
      userPhone: '',
      showInvoice: false,
      userThumb: '',
      applySuccess: false,
      screenWidth: document.body.clientWidth,
      timeStamp: Date.now()
    }
  },
  created () {
    this.getTokenAndQuery()
  },
  mounted () {
    this.token = window.localStorage.getItem('token')
    // this.sid = this.$route.query.sid || this.global.area_id || ''
    this.sid = (this.$route.query && (this.$route.query.sid || this.$route.query.aid)) || this.global.area_id || ''
    if (!this.token || this.token === null) {
      // localStorage.setItem('linkurl', window.location.href)
      let linkurl =
        this.$route.fullPath + (
          this.$route.fullPath.indexOf('qd=') === -1 ? (
            `${this.global.hashParam.qd ? `${this.$route.fullPath.indexOf('?') === -1 ? '?' : '&'}qd=` + this.global.hashParam.qd : ''}`
          ) : '')
      window.localStorage.setItem('linkurl', linkurl)
      this.$router.push(this.formatHref('/login', {sid: this.sid}))
      return
    }
    this.getUserInfo()
    window.addEventListener('resize', () => {
      if (this.$route.path && this.$route.path.includes('/center')) {
        this.screenWidth = document.body.clientWidth
      }
    })
  },
  watch: {
    $route (to, from) {
      // console.log(to, from)
      if (to.query && to.path.includes('/user_center')) {
        // this.timeStamp = Date.now()
        if ((Object.keys(to.query).includes('selected') || Object.keys(to.query).includes('active'))) {
          let num = to.query.selected || to.query.active || 0
          let q = parseInt(num)
          if (this.selectedTab !== q) {
            this.toggleTabs(q)
          }
        } else {
          this.toggleTabs(0)
        }
        this.sid = to.query.sid || this.global.area_id || ''
        this.$forceUpdate()
      }
    }
  },
  methods: {
    toHome () {
      window.location.href = this.formatHref(this.homeUrl || '/')
    },
    applyInvoiceSuccess () {
      this.applySuccess = true
    },
    openInvoice () {
      // 切换到开具发票的部分
      this.showInvoice = true
    },
    getTokenAndQuery () {
      if (this.$route.query && (this.$route.query.selected || this.$route.query.active)) {
        let num = this.$route.query.selected || this.$route.query.active
        this.selectedTab = parseInt(num)
        this.$forceUpdate()
      }
      this.token = window.localStorage.getItem('token')
      if (!this.token || this.token === null) {
        // 保存当前链接，跳转登录
        return false
      }
    },
    triggerTabs (index) {
      if (this.selectedTab !== parseInt(index)) {
        let query = { sid: this.sid, selected: index }
        if (this.global.hashParam['qd']) {
          query.qd = this.global.hashParam['qd']
        }
        this.$router.push(this.formatHref('/user_center', query))
      }
    },
    toggleTabs (index) {
      this.selectedTab = parseInt(index)
      this.showInvoice = false
    },
    // 用户信息
    regetUserInfo (res) {
      if (res) {
        this.getUserInfo()
      }
    },
    getUserInfo () {
      let url = `${this.global.urlNew['getUserSetting']}?token=${this.token}`
      this.$http
        .jsonp(url)
        .then((data) => {
          return data.json()
        })
        .then((data) => {
          // console.log('get-user-info ', data)
          if (data.status === '200') {
            this.userName = data.data.name
            this.userPhone = data.data.phone
            if (data.data.thumbs) {
              if (typeof data.data.thumbs === 'string' && data.data.thumbs.trim() !== '') {
                this.userThumb = JSON.parse(data.data.thumbs)[0].fileUrl
              } else if (typeof data.data.thumbs === 'object' && data.data.thumbs[0] && data.data.thumbs[0].fileUrl) {
                this.userThumb = data.data.thumbs[0].fileUrl
              }
            }
            // this.userThumb = JSON.parse(data.data.thumbs)[0].fileUrl;
            this.phone = data.data.phone
            this.company = data.data.company
            this.position = data.data.position
            this.department = data.data.department
            this.email = data.data.email
          } else {
            console.log('获取用户信息失败')
            this.$toast('当前登录状态已过期，请重新登录')
            // this.global.isLogined()
            window.localStorage.removeItem('logins')
            window.localStorage.removeItem('token')
            window.localStorage.removeItem('uid')
            if (data.code === '1001') {
              let linkurl =
                this.$route.fullPath + (
                  this.$route.fullPath.indexOf('qd=') === -1 ? (
                    `${this.global.hashParam.qd ? `${this.$route.fullPath.indexOf('?') === -1 ? '?' : '&'}qd=` + this.global.hashParam.qd : ''}`
                  ) : '')
              window.localStorage.setItem('linkurl', linkurl)
              this.$router.push(this.formatHref('/login', { sid: this.sid }))
            } else {
              const params = {}
              if (this.$route.qd || this.global.hashParam.qd) {
                params.qd = this.$route.query.qd || this.global.hashParam.qd
              }
              setTimeout(() => {
                this.$router.push(this.formatHref('/home', params))
              }, 800)
            }
          }
        })
    },
    // 复制链接
    copyUrl (item) {
      window.getSelection().removeAllRanges()
      let copyDOM = document.getElementById(`${item.number}`)
      let range = document.createRange()
      range.selectNode(copyDOM)
      window.getSelection().addRange(range)
      try {
        // let successful = document.execCommand('copy')
        window.alert('复制成功', 800)
      } catch (e) {
        window.alert('复制失败')
      }
      window.getSelection().removeAllRanges()
    }
  }
}
</script>

<style lang='scss' scoped>
.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
}
.icon-left {
  color: #9e9e9e;
}
.icon-right {
  color: #eeeeee;
}
.top100 {
  --main-color: #ffde1d;
}
.ee {
  --main-color: #3687c9;
}
.mpd {
  --main-color: #1889cb;
}
.giac {
  --main-color: #003177;
}
.a2m {
  --main-color: #0a70c5;
}
.hipm {
  --main-color: #48a3d8;
}
.user-center-wrapper {
  min-height: 100vh;
  background-color: #f8f8f8;
}

/* 用户信息 */
.user-info-con {
  width: 100%;
  height: 148px;
  text-align: center;
  margin: 0 auto;
  background-color: var(--main-color);
  position: relative;
  overflow: hidden;
}
.user-info-item {
  width: 100%;
  max-width: 1200px;
  padding: 34px 15px 0 15px;
  text-align: left;
  position: absolute;
  z-index: 2;
  display: flex;
  .user-thumb {
    border: 1px solid #ffffff;
    padding: 3px;
  }
  .user-name {
    padding-left: 14px;
    p {
      font-size: 21px;
      font-weight: 500;
      color: #222;
      padding: 15px 0;
      margin: 0;
    }
  }
}
@media (min-width: 1200px) {
  .user-info-item {
    left: 50%;
    margin-left: -600px;
  }
}
.user-info-item > img {
  width: 90px;
  height: 90px;
  border-radius: 50px;
}

/* 信息中心 */
.user-center p {
  margin-bottom: 0;
}
.user-center {
  max-width: 1200px;
  margin: 25px auto 0;
  display: flex;
  padding-bottom: 50px;
}

/* 信息中心-左 */
.sider {
  --tabs-count: 4;
  flex-shrink: 0;
  display: inline-block;
  width: 20%;
  max-height: calc(var(--tabs-count) * 62px); // 186px
  margin-right: 23px;
  background: #fff;
  .tabs-wrapper {
    .tabs {
      position: relative;
      .tabs-pane {
        border-top: 2px solid #f8f8f8;
        padding: 18px 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 16px;
        font-weight: 500;
        color: #333;
        >div {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          cursor: url("../assets/img/images/mouse3.png"), auto;
        }
        .icon {
          font-size: 20px;
          &[class*='el-icon'] {
            // font-size: 24px;
            font-weight: bold;
            color: #9e9e9e;
          }
        }
        p {
          margin-left: 16px;
          margin-right: auto;
        }

        &.selected {
          color: var(--main-color);
          border-left-color: var(--main-color);
          .icon-left,
          .icon-right {
            color: var(--main-color)
          }
        }
      }
      &::before {
        content: '';
        width: 6px;
        height: 62px;
        position: absolute;
        top: 0;
        left: 0;
        background: var(--main-color);
        transition: all linear 0.3s;
      }
      &.selected0::before {
        top: 0;
      }
      &.selected1::before {
        top: 62px;
      }
      &.selected2::before {
        top: 124px;
      }
      &.tab-count-4 {
        &.selected2::before {
          // top: 186px;
          top: 185px;
        }
        &.selected4::before {
          // top: 124px;
          top: 123px;
        }
      }
    }
  }
}

.sider .tabs-wrapper {
  margin-bottom: 300px;
}
/* 信息中心-右 */
.user-content {
  width: 936px;
  // min-height: 690px;
  min-height: 500px;
  background: rgba(255, 255, 255, 1)
}
/* 发票提交成功 */
.invoice-success {
  width: 100%;
  padding: 70px 30px;
  text-align: center;
  background-color: #ffffff;
  div:not(.invoice-success-con) {
    width: fit-content;
    margin: 0 auto;
    display: flex;
  }
  img {
    width: 80px;
    height: 80px;
    padding: 9px 9px 5px 5px;
    border-radius: 50px;
    background-color: #1bbb99;
  }
  h4 {
    font-size: 20px;
    font-weight: 400;
    line-height: 80px;
    padding-left: 30px;
    color: #444444;
  }
}
.invoice-success-con {
  width: fit-content;
  text-align: left;
  margin: 0 auto;
  margin-top: 60px;
  p {
    font-size: 16px;
    font-weight: 400;
    color: #999999;
    margin-bottom: 15px;
    span {
      color: #444444;
    }
    a {
      color: var(--main-color);
    }
  }
}

@media (max-width: 767px) {
  .user-center-wrapper {
    width: 100vw;
    .user-center {
      margin: 0;
      padding: 0;
      width: 100%;
      .sider {
        display: none;
      }
      .user-content {
        width: 100%;
      }
    }
    .invoice-success {
      padding: 10vh 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/viewsNew/UserCenterNew.vue